import React, { useState } from "react";
import { useGetTermsQueryData } from "src/hooks/reactquery";
import { useModal } from "src/hooks/useModal";
import { useRecoilState } from "recoil";
import Modal from "src/component/common/Modal/Modal";
import { TYPE_REFUND_TERMS } from "src/service/constant/cmdtype";
import checkbox from "src/assets/common/join/checkbox.png";
import checkbox_active from "src/assets/common/join/active_checkbox.png";
import { RefundTermYN } from "src/store/recoil/refund";
import * as S from "src/styles/views/Support/refund";

const RefundTerms = () => {
  const [modalOption, setModalOption] = useState({ title: "", content: "" });
  const { data: TermsQueryData } = useGetTermsQueryData(TYPE_REFUND_TERMS);
  const { isOpen, toggle } = useModal();
  const [termsAgree, setTermsAgree] = useRecoilState(RefundTermYN);

  const TermsModalOpen = (title: string, content: string) => {
    setModalOption({ title: title, content: content });
    toggle();
  };

  return (
    <S.RefundTerms>
      <img
        src={termsAgree ? checkbox_active : checkbox}
        alt="부분약관"
        onClick={() => setTermsAgree(!termsAgree)}
      />
      <p
        onClick={() =>
          !!TermsQueryData?.Body &&
          TermsModalOpen(
            TermsQueryData?.Body[0].LgupTitle,
            TermsQueryData?.Body[0].LgupTerms
          )
        }
      >
        <span>개인정보 수집 및 이용동의(필수)</span>
      </p>
      <Modal
        isOpen={isOpen}
        type="terms"
        option={modalOption}
        ClickFunc={() => toggle()}
      />
    </S.RefundTerms>
  );
};
export default RefundTerms;
